import { RouteConfig } from "vue-router";

export const REmployerCompanyDocumentsBrowse: RouteConfig = {
  path: "",
  name: "EmployerCompanyDocumentsBrowse",
  component: () =>
    import(
      /* webpackChunkName: "employer-company-documents-browse" */
      "./VEmployerCompanyDocumentsBrowse.vue"
    ),
  meta: {
    title: "Company",
    label: "documents",
  },
};
